module.exports = __webpack_public_path__ + "img/pleasure-icon-10.babcfd9b.svg";